import React from "react";

/**
 * Single source of truth for the BHK + floor selector.
 * Render it in as many places as you like (Property Details header,
 * Floor Plan header, sticky price block...) — every instance reads and
 * writes the same state that lives in BuyPropertyDetail.
 */
export default function BhkFloorTabs({
  bhkdata = [],
  activeBhk,
  activeFloorDetail,
  onBhkChange,
  onFloorChange,
  showFloors = true,
  className = "",
  showBhk = true,
}) {
  if (!bhkdata.length) return null;

  const current = bhkdata.find((b) => b.type === activeBhk);
  const floors = current?.fullDetails || [];

  const floorLabel = (d) =>
    `${d?.floor === 0 ? "Ground Floor" : `Floor: ${d?.floor}`}` +
    `${d?.facing ? ` - ${d.facing}` : ""}`;

  return (
    <div className={`bhk-floor-tabs ${className}`}>
        {showBhk && (
      <div className="bhk-tabs">
        {bhkdata.map((item) => (
          <button
            type="button"
            key={item.type}
            aria-pressed={activeBhk === item.type}
            className={`bhk-tab ${activeBhk === item.type ? "active" : ""}`}
            onClick={() => onBhkChange?.(item)}
          >
            {item.type}
          </button>
        ))}
      </div>
        )}
      {showFloors && floors.length > 0 && (
        <div className="floor-sub-tabs">
          {floors.map((detail, idx) => {
            const isActive = activeFloorDetail?.id === detail?.id;
            return (
              <button
                type="button"
                key={detail?.id ?? idx}
                aria-pressed={isActive}
                className={`floor-tab ${isActive ? "active" : ""}`}
                onClick={() => onFloorChange?.(detail, idx)}
              >
                {floorLabel(detail)}
              </button>
            );
          })}
        </div>
      )}
    </div>
  );
}